<script>
import options from './StafetDeltagPaaHoldStepSelectTeam.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-join-a-team-step-select-team kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.selectYourHoldTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <FormInputDropdown
        :modelValue="teamName"
        v-model="teamName"
        :label="labels.selectYourHoldLabel"
        :placeholder="labels.selectYourHoldLabel"
        :isRequired="true"
        fieldName="teamName"
        :selectOptions="teams"
        :onChangeCallback="(e) => validateField('teamName', e.target.value)"
        :errorMessageLabel="labels.selectYourHoldErrorMessage"
        :isValidationError="handleErrorMessage('teamName')"
      />
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        :modelValue="isChild.toString()"
        v-model="isChild"
        :label="labels.isChildBoolLabel"
        fieldName="isChild"
        :onChangeCallback="(e) => validateField('isChild', e.target.checked)"
      />
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <section class="kb-cta-box-checkbox">
        <div class="kb-cta-box-checkbox__box-content-container">
          <div class="kb-cta-box-checkbox__box-content">
            <div class="kb-cta-box-checkbox__box-circle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 67 69"
              >
                <path
                  fill="#3C3C3C"
                  d="M27.15 35.49a9.491 9.491 0 0 0-1.94 1.08 116.119 116.119 0 0 0-.85-12.13l-3 .34v.18a95.5 95.5 0 0 1 .77 13.14 14.897 14.897 0 0 1-1.75 3.8c-.33.51-.51.84-.54.9l2.59 1.51.55-.92c1.05-1.62 3.09-4.25 5.24-5.11A11.85 11.85 0 0 1 41 40.21l.18.18c.56.54 1.55 1.52 1.84 1.86.29.34 1.25 1.74 1.75 2.49l2.57-1.55a17.292 17.292 0 0 0-1.59-2.3c-.16-.22-.31-.42-.43-.56-.28-.34-.89-.95-1.37-1.43a13.26 13.26 0 0 1 6.38-4.71c3.39-1.27 8.56-1.78 13.94 3l2-2.24c-7-6.21-13.83-4.85-17.29-3.48A16.73 16.73 0 0 0 41.59 37a14.53 14.53 0 0 0-14.44-1.51Z"
                />
                <path
                  fill="#3C3C3C"
                  d="M65.83 65.72c-7.45 1.33-17.74-3.25-17.84-3.3l-.57-.25-.58.22c-.23.09-22.31 8.28-39.25-9.06a3 3 0 0 0-1.87-.69 2.72 2.72 0 0 1-1.66-.54c-.59-.72-.35-2.08-.26-2.6a203.32 203.32 0 0 1 6.58-26.61c1-3.24 2-6.58 3.1-10.53l17.78-8.15c1.61 1.08 3.63 4.43 4.83 7-2 3.39-4.58 6.42-5.49 6.43A8.331 8.331 0 0 1 27.84 16l-1.16-1-1.09 1a3.411 3.411 0 0 0-.46.47c-.19.22-.63.74-4.63.89l.11 3c3.92-.14 5.37-.66 6.23-1.36a8.83 8.83 0 0 0 3.24 1.59c1.15.21 4.33-.22 9-8.56l.37-.65-.3-.68c-.59-1.36-3.7-8.21-7.33-9.57l-.58-.22L11 10.22l-.19.67c-1.16 4.2-2.22 7.72-3.26 11.13A205.997 205.997 0 0 0 .84 49c-.14.79-.57 3.21.89 5a5.2 5.2 0 0 0 3.62 1.62h.31c16.66 16.79 37.83 11 41.65 9.74 2 .84 9 3.56 15.57 3.56a19.82 19.82 0 0 0 3.47-.29l-.52-2.91Z"
                />
              </svg>
            </div>
            <div>
              <h2 class="kb-cta-box-checkbox__box-title">
                {{ labels.joinAsFighterTitle }}
              </h2>
              <p class="kb-cta-box-checkbox__box-description">
                {{ labels.joinAsFighterDescription }}
              </p>

              <div class="kb-cta-box-checkbox__box-input">
                <FormCheckbox
                  :modelValue="isFighter.toString()"
                  v-model="isFighter"
                  :label="labels.joinAsFighterBoolLabel"
                  fieldName="isFighter"
                  :onChangeCallback="
                    (e) => validateField('isFighter', e.target.checked)
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <template v-if="isFighter">
      <div>
        <h2 class="kb-stafet-step__title">
          {{ labels.selectYourFighterTshirtTitle }}
        </h2>

        <p class="kb-stafet-step__description">
          {{ labels.selectYourFighterTshirtDescription }}
        </p>
      </div>

      <div class="kb-stafet-step__input-wrapper">
        <FormInputDropdown
          :modelValue="shirtSize"
          v-model="shirtSize"
          :label="labels.selectYourFighterTshirtLabel"
          fieldName="shirtSize"
          :selectOptions="tshirtSizes"
          :isRequired="true"
          :errorMessageLabel="labels.selectYourFighterTshirtErrorMessage"
          :placeholder="labels.selectYourFighterTshirtLabel"
          :onChangeCallback="(e) => validateField('shirtSize', e.target.value)"
          :isValidationError="handleErrorMessage('shirtSize')"
        />
      </div>

      <div>
        <h2 class="kb-stafet-step__title">
          {{ labels.fighterArrangementTitle }}
        </h2>

        <p class="kb-stafet-step__description">
          {{ labels.fighterArrangementDescription }}
        </p>
      </div>

      <FormCheckbox
        :modelValue="isFighterFreeLunch.toString()"
        v-model="isFighterFreeLunch"
        :label="labels.fighterArrangementBoolLabel"
        fieldName="isFighterFreeLunch"
        :onChangeCallback="
          (e) => validateField('isFighterFreeLunch', e.target.checked)
        "
      />
    </template>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        :modelValue="addMoreParticipants.toString()"
        v-model="addMoreParticipants"
        :label="labels.registerDeltagereBoolLabel"
        fieldName="addMoreParticipants"
        :onChangeCallback="(e) => toggleAddMoreParticipants(e.target.checked)"
      />

      <div v-if="addMoreParticipants">
        <StafetAddDeltager
          :labels="labels"
          :onChangeCallback="updateAddParticipants"
          :data="participants"
          :displayInputError="displayInputError"
          :excludeMail="false"
        />
      </div>
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep1"
    />
  </article>
</template>
